export default __webpack_public_path__ + "static/media/alarm.42f574b0.mp4";